import { Component, Input, OnInit } from '@angular/core';
import { DialogflowService } from '../../services/dialogflow.service';
import { SharedDataService } from '../../services/shared-data.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css']
})
export class ChatComponent implements OnInit {

  dialogflowLastAnswer: object = {};
  response = 'Bonjour je suis le Drawing Bot! On fait un dessin ? :p';
  @Input()
  message = '';
  helpMessage = 'Voici comment converser avec le Drawing Bot:<br/> coucou';

  constructor(private dialogflowService: DialogflowService,
    private sharedDataService: SharedDataService) {

    this.sharedDataService.getDialogflowAnswer().subscribe(answer => {
      this.dialogflowLastAnswer = answer;
      this.response = '';
      for (const msg of this.dialogflowLastAnswer['result']['fulfillment']['messages']) {
        this.response += msg.speech + '\n';
      }
    });
  }


  ngOnInit() {

  }

  send() {
    if (this.message.length > 0) {
      this.dialogflowService.sendMessage(this.message).subscribe(
        res => this.sharedDataService.updateDialogflowAnswer(res)
      );
      this.message = '';
    }
  }

  isEnter(event) {
    if (event.keyCode === 13) {
      this.send();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/chat/chat.component.ts